import { createErrorRegistry } from '../../researcher/redux/errors/registry.errors';
import { isQualificationRejection } from './result/util.result';
import { selectSurveyClient } from './survey-client/selectors.survey-client';
import {
  ANSWERS__GET,
  CURRENCIES__FETCH,
  ELEMENTS__FETCH,
  PAGES__FETCH,
  RESULT__FETCH,
  RESULT__INIT,
  SURVEYS__FETCH_ACTIVE,
  SURVEYS__GET,
} from './constants';

export const participantErrorRegistry = createErrorRegistry({
  criticalTypes: [
    ANSWERS__GET,
    CURRENCIES__FETCH,
    ELEMENTS__FETCH,
    PAGES__FETCH,
    RESULT__FETCH,
    RESULT__INIT,
    SURVEYS__FETCH_ACTIVE,
    SURVEYS__GET,
  ],
  ownedPredicates: [
    (error) => error.originalType === RESULT__INIT && isQualificationRejection(error.axiosError),
  ],
  selectIsInitialized: (state) => Boolean(selectSurveyClient(state).isInitialized),
});
